// booking.lang.en.js
const bookingEN = {
	weekLabel: "{start} – {end}",
	noSlots: "No available times",
	staff: {
		title: "Staff",
		any: "Any staff",
	},
	services: {
		title: "Services",
		add: "+ Add Service",
		selected: "{name} • {duration} min — ${price}",
	},
	guest: {
		title: "Your Info",
		fullName: "Full Name",
		email: "Email",
	},
	buttons: {
		confirm: "Confirm Booking",
		confirmReschedule: "Confirm Reschedule",
		close: "Close",
	},
	toast: {
		noServiceOrTime: "Please pick at least one service and a time",
		missingService: "Please select at least one service.",
		missingTime: "Please select a time.",
		missingGuest: "Please enter your name and email",
		noStaff: "No staff available for that time",
		pastTime: "You can’t book a time in the past.",
		bookingConfirmed: "Booking confirmed! Email sent.",
		rescheduled: "Booking rescheduled successfully!",
		couldNotReschedule: "Could not reschedule booking",
		couldNotConfirm: "Could not confirm booking",
		timeInvalidated: "The selected time is no longer available for the chosen services.",
		missingStaff: "Please pick atleast one staff",

	},
	timeFilters: {
		morning: "Morning",
		afternoon: "Afternoon",
		evening: "Evening",
	},
	summary: {
		noServices: "No services selected",
		oneService: "1 service",
		multipleServices: "{n} services",
	},
};

export default bookingEN;
